<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <router-link
      :to="{
        name: 'ProjectEdit',
        params: {
          id: $parent.project.PROJECT_TYPE_LOAN.ID
        }
      }"
      class="stl-link-blue stl-fw-bold_"
      style="text-decoration: underline"
    >
      {{ $parent.project.PROJECT_TYPE_LOAN.UF_NUMBER }} -
      {{ $parent.project.PROJECT_TYPE_LOAN.UF_NAME }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "uf_scalable_product_project",
  methods: {}
};
</script>

<style scoped></style>
